import { connect } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';
import { IReduxRootState } from '../../../app/reduxRootState.interface';
import { NotificationAction } from '../../../app/common/notifications/notificationsActionType';
import { UpdateUsernameActions } from './updateUsernameActions';
import { UpdateUsernameAction } from './updateUsernameActionType';
import {
    IUpdateUsernameFormDispatchProps,
    IUpdateUsernameFormStateProps,
    UpdateUsernameForm,
} from './UpdateUsernameForm';
import { IUpdateUsernameRequest } from './updateUsernameRequest';

function mapStateToProps(state: IReduxRootState) {
    const {
        app: {
            presentationConfig: {
                visibleFields: { account },
            },
        },
    } = state;

    const usernameValidatorRules = account.username.validatorRules;

    return {
        challengerPid: state.app.appConfig.CHALLENGER_ENABLED
            ? state.app.appConfig.CHALLENGER_PIDS.ACCOUNT_SECURITY
            : '',
        clientId: state.app.clientConfig ? state.app.clientConfig.clientId : undefined,
        isSubmitting: state.accountSecurity.updatingUsername,
        member: state.member,
        usernameValidatorRules: usernameValidatorRules,
        sessionRevocationEnabled: state.app.appConfig.SESSION_REVOCATION_ENABLED ?? true, // Enabled by-default
    };
}

function mapDispatchToProps(
    dispatch: ThunkDispatch<IReduxRootState, {}, UpdateUsernameAction | NotificationAction>,
) {
    return {
        updateUsername: (data: IUpdateUsernameRequest, signOutFromAllDevices: boolean) => {
            dispatch(UpdateUsernameActions.updateMemberUsername(data, signOutFromAllDevices));
        },
    };
}

const UpdateUsernameFormContainer = connect<
    IUpdateUsernameFormStateProps,
    IUpdateUsernameFormDispatchProps,
    {},
    IReduxRootState
>(
    mapStateToProps,
    mapDispatchToProps,
)(UpdateUsernameForm);

export default UpdateUsernameFormContainer;
